import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18n from 'src/utils/translate';
import { showLoginModal, showSignupModal } from 'src/modules/shared/modal/actions';
import { trackFootfallEvent } from 'src/utils/footfall';

import styled from 'styled-components';
import { FadeBottom } from 'styles-js/mixins/fade';
import { titleLarge, titleMedium } from 'styles-js/mixins/typography';
import { LinkButton } from 'styles-js/buttons';
import EventType from 'src/constants/footfallEventTypes';

const Container = styled.div`
  position: relative;
  margin-bottom: 60px;
  background-color: ${props => props.theme.colorWhite};
  ${FadeBottom};

  ::before {
    background: linear-gradient(to top, ${props => props.theme.colorWhite}, hsla(0,0%,100%,0));
  }

  @media (max-width: ${props => props.theme.screenXsMin}) {
    ::before {
      top: -50px;
      height: 50px;
    }
  }
`;

const Title = styled.p<{username?: boolean}>`
  ${titleLarge};
  font-family: ${props => props.theme.fontFamilyMain};
  font-weight: ${props => props.theme.fontWeightBold};
  padding-top: 10px;
  margin-bottom: ${props => props.username ? '8px' : '20px'};
`;

const NotYou = styled.p`
  margin-bottom: 22px;
`;

const LoginButton = styled.button`
  margin-top: 12px;
  padding: 13px 20px;

  @media (max-width: ${props => props.theme.screenXsMax}) {
    padding: 9px 20px;
  }
`;

const Subtitle = styled.p`
  ${titleMedium};
  font-family: ${props => props.theme.fontFamilyMain};
  font-weight: ${props => props.theme.fontWeightBold};
  margin: 28px 0 20px;
`;

const List = styled.ul`
  padding-left: 20px;
  margin-bottom: 60px;
`;

const ListItem = styled.li`
  margin-bottom: 15px;
`;

const MoreLinks = styled.p`
  border-top: 1px solid ${props => props.theme.colorGreyLight};
  padding-top: 10px;
`;

const LoginBlockMessageBox = () => {
  const username: string = useSelector((state: any) => state.pages.singlePost.loginBlockUsername);
  const dispatch = useDispatch();

  const onLoginSuccess = () => {
    trackFootfallEvent(EventType.CLICKED, { clickType: 'login-completed' });
  };

  return (
    <Container>
      {username ? (
        <React.Fragment>
          <Title username>{i18n.t('Hi')} {username}!</Title>
          <NotYou>{i18n.t('Not you?')} <LinkButton onClick={() => dispatch(showLoginModal({ onLoginSuccess: onLoginSuccess }))}>{i18n.t('Log in here')}</LinkButton></NotYou>
        </React.Fragment>
      ) : (
        <Title>{i18n.t('Welcome back!')}</Title>
      )}
      <p>{i18n.t('Please log in to continue reading')}</p>
      <LoginButton className="btn btn-primary" onClick={() => dispatch(showLoginModal({ onLoginSuccess: onLoginSuccess }))}>{i18n.t('Log in to your account')}</LoginButton>

      <Subtitle>{i18n.t('Once logged in, you\'ll be able to:')}</Subtitle>
      <List>
        <ListItem>{i18n.t('Connect with others like you')}</ListItem>
        <ListItem>{i18n.t('See members only features and get recommendations')}</ListItem>
        <ListItem>{i18n.t('Support the community by letting them know you are here')}</ListItem>
      </List>

      <MoreLinks>
        {i18n.t('Please')}
        {' '}
        <LinkButton onClick={() => dispatch(showSignupModal())}>{i18n.t('join')}</LinkButton>
        {' ' + i18n.t('or') + ' '}
        <LinkButton onClick={() => dispatch(showLoginModal({ onLoginSuccess: onLoginSuccess }))}>{i18n.t('log in')}</LinkButton>
        {' '}
        {i18n.t('to continue reading')}
      </MoreLinks>
    </Container>
  );
};

export default LoginBlockMessageBox;
